import { queryVuePagePaths } from '../../apis/modules/common';
import { defineStore } from 'pinia';

interface AppPagePaths {
  thisAppName: string; // 当前应用名,对应部署应用名
  vuePagePaths: any;
}

// 应用白名单信息
export const useAppPagePaths = defineStore({
  id: 'appPagePaths',
  state: (): AppPagePaths => {
    return {
      thisAppName: '',
      vuePagePaths: {},
    };
  },
  getters: {},
  actions: {
    /**
     * 设置当前应用名/获取白名单
     */
    init(appName: string, params: { currentCorpId: string }) {
      this.thisAppName = appName;
      this.getVuePagePaths(params);
    },
    async getVuePagePaths(params: { currentCorpId: string }) {
      try {
        const { data } = await queryVuePagePaths(params);
        this.vuePagePaths = data || {};
      } catch (error) {
        console.error('api queryVuePagePaths error ===>', error);
      }
    },
    // 获取跳转路径是否同应用
    getIsCurrentApp(targetPathName: string) {
      let targetAppName = '';
      Object.keys(this.vuePagePaths).find((item) => {
        const reg = new RegExp(item.replace(/\//g, '\\/').replace(/\*/g, '.*'));
        const isVueWhitePath = reg.test(`/${targetPathName}`);
        if (isVueWhitePath) {
          targetAppName = this.vuePagePaths[item];
        }
      });
      return this.thisAppName === targetAppName;
    },
  },
});
